import { useRouter } from 'vue-router'
import {
  applyDestination,
  resolveAfterScenarioComplete,
  resolveOnboardingDestination
} from './resolver'
import type { OnboardingDestination } from './types'
import { useOnboardingContext } from './useOnboardingContext'

export function useOnboardingResolver () {
  const router = useRouter()
  const ctx = useOnboardingContext()

  function goAfterLogin (): void {
    applyDestination(router, resolveOnboardingDestination(ctx.value))
  }

  function goAfterScenario (slug: string): void {
    applyDestination(router, resolveAfterScenarioComplete(slug, ctx.value))
  }

  function applyDest (dest: OnboardingDestination): void {
    applyDestination(router, dest)
  }

  return { goAfterLogin, goAfterScenario, applyDestination: applyDest }
}
